import React, { useState } from 'react';
import { faqs } from '../data';
import './FAQ.css';

function Accordion({ question, answer }) {
  const [open, setOpen] = useState(false);
  return (
    <div className={`faq-item${open ? ' open' : ''}`}>
      <button className="faq-question" onClick={() => setOpen(!open)}>
        <span>{question}</span>
        <span className="faq-arrow">{open ? '−' : '+'}</span>
      </button>
      {open && <div className="faq-answer">{answer}</div>}
    </div>
  );
}

export default function FAQ() {
  return (
    <>
      <div className="page-hero">
        <div className="container">
          <div className="section-tag">Help Centre</div>
          <h1>Frequently Asked Questions</h1>
          <p>Everything you need to know before your Morocco adventure</p>
        </div>
      </div>

      <section className="section section-white">
        <div className="container faq-layout">
          <div className="faq-content">
            {faqs.map(section => (
              <div key={section.category} className="faq-section">
                <h2 className="faq-category">{section.category}</h2>
                <div className="faq-list">
                  {section.questions.map((q) => (
                    <Accordion key={q.q} question={q.q} answer={q.a} />
                  ))}
                </div>
              </div>
            ))}
          </div>

          <div className="faq-sidebar">
            <div className="faq-contact-box">
              <div style={{ fontSize: 32, marginBottom: 12 }}>💬</div>
              <h3>Still have questions?</h3>
              <p>Our team is available 7 days a week. Fastest response via WhatsApp.</p>
              <a
                href="https://wa.me/212694401220"
                target="_blank" rel="noreferrer"
                className="btn btn-sm"
                style={{ background: '#25d366', color: '#fff', textDecoration: 'none', marginTop: 16, display: 'inline-flex' }}
              >
                Chat on WhatsApp
              </a>
              <a href="/contact" className="btn btn-ghost btn-sm" style={{ marginTop: 8, display: 'inline-flex' }}>
                Send Email
              </a>
            </div>
            <div className="faq-popular">
              <h3>Popular Tours</h3>
              <ul>
                <li><a href="/tours/atlas-mountains-day-trip">Atlas Mountains Day Trip</a></li>
                <li><a href="/tours/agafay-desert-day-trip">Agafay Desert Tour</a></li>
                <li><a href="/activities/hot-air-balloon-marrakech">Hot Air Balloon</a></li>
                <li><a href="/activities/marrakech-cooking-class">Cooking Class</a></li>
                <li><a href="/tours/ouzoud-waterfalls-trip">Ouzoud Waterfalls</a></li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
